import { DefaultService } from '@/services/DefaultService';

export default class ExportacaoLogService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env)
    }

    save(exp) {
        return this._http.post(`${this._env}/exportlog/save`, exp, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Erro ao salvar o log da exportação');
        });
    }
}